import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";

export const filterFieldConsts = {
  JOB_NUMBER: "jobNumber",
  JOB_NAME: "jobName",
  CUSTOMER_NAME: "companyId",
  JOB_TYPE: "jobType",
  EQUIPMENT: "equipment",
  MATERIAL_CATEGORY: "materialCategory",
  MATERIAL_TYPE: "materialType",
  SALES_PERSON: "salesPersonId",
};

export const getFilterFieldList = ({
  jobNoSearch,
  jobNameSearch,
  customerSearch,
  jobTypeSearch,
  equipmentSearch,
  materialCategorySearch,
  materialTypeSearch,
  salesPersonSearch,
  searchJobNumbers,
  searchJobNames,
  searchCustomers,
  searchTypes,
  searchEquipment,
  searchMaterialCategories,
  searchMaterialTypes,
  salesPersonTypes,
  isAffectedView = false,
}) => [
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    label: "Job #",
    name: filterFieldConsts?.JOB_NUMBER,
    placeholder: "Select",
    bordered: true,
    setSearch: searchJobNumbers,
    searchValue: jobNoSearch,
  },
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    label: "Job Name",
    name: filterFieldConsts?.JOB_NAME,
    placeholder: "Select",
    bordered: true,
    setSearch: searchJobNames,
    searchValue: jobNameSearch,
  },
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    label: "Customer",
    name: filterFieldConsts?.CUSTOMER_NAME,
    placeholder: "Select",
    bordered: true,
    setSearch: searchCustomers,
    searchValue: customerSearch,
  },
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    label: "Type",
    name: filterFieldConsts?.JOB_TYPE,
    placeholder: "Select",
    bordered: true,
    setSearch: searchTypes,
    searchValue: jobTypeSearch,
  },
  ...(!isAffectedView
    ? [
        {
          type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
          label: "Equipment",
          name: filterFieldConsts?.EQUIPMENT,
          placeholder: "Select",
          bordered: true,
          setSearch: searchEquipment,
          searchValue: equipmentSearch,
        },
      ]
    : []),
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    label: "Material Category",
    name: filterFieldConsts?.MATERIAL_CATEGORY,
    placeholder: "Select",
    bordered: true,
    setSearch: searchMaterialCategories,
    searchValue: materialCategorySearch,
  },
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    label: "Material Type",
    name: filterFieldConsts?.MATERIAL_TYPE,
    placeholder: "Select",
    bordered: true,
    setSearch: searchMaterialTypes,
    searchValue: materialTypeSearch,
  },
  {
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    label: "Sales Person",
    name: filterFieldConsts?.SALES_PERSON,
    placeholder: "Select",
    bordered: true,
    setSearch: salesPersonTypes,
    searchValue: salesPersonSearch,
  },
];
